import React from "react";
import styles from "../styles/about.css";
import Skills from "./Skills";
import { motion } from "framer-motion";

const About = (props) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ type: "just", duration: 0.5 }}
      className="about"
    >
      <img
        width={"100%"}
        alt={"computer-illustration"}
        src="https://mattfarley.ca/img/hero-devices.svg"
      />
      <motion.div id="about" className="about-me">
        <motion.div
          className="content"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ type: "just", duration: 0.5 }}
        >
          <h2>Hi, My name is Mayowa Alexander Paul. Nice to meet you.</h2>
          <br />
          <p className="caption">
            As a self-taught iOS software engineer, I'm passionate
            about creating innovative, user-centered, business-driven apps.
            Solving complex problems and making a real difference in people's
            lives through technology excites me. When not working, I enjoy
            spending time with family, reading books on personal development,
            volunteering in my local community, and exploring new cultures
            through travel. I'm committed to delivering high-quality,
            user-friendly iOS apps and would love to connect with you to discuss
            your iOS development needs.
          </p>
        </motion.div>
      </motion.div>
      <Skills />
    </motion.div>
  );
};

export default About;
